// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"yI-z","carouselContainer":"zI-z"};